export default __webpack_public_path__ + "static/media/mixology-desktop-pattern@3x.6a8f1ddd.png";